import React from 'react'
import useTimer from '../../hooks/useTimer';
import './DayClock.css'

export default function DayClock() {
  const {curDate, flipYearMode} = useTimer();
  return (
    <div className='dayClock' onClick={flipYearMode}>{curDate}</div>
  )
}
